import React from "react";

export interface TurboPaymentContextValue {
    showChangeAnimation?: boolean;
    onSlideButtonDrag: (leftPosition: number, containerWidth: number) => void;
    //TODO: remove optional params in clean up
    onSlideButtonSuccess: (leftPosition?: number, containerWidth?: number) => void;
}

export const TurboPaymentContext = React.createContext<TurboPaymentContextValue>({
    showChangeAnimation: false,
    onSlideButtonDrag: () => void 0,
    onSlideButtonSuccess: () => void 0,
});
